function walkGameMapElement(conf){
    PIXI.Container.call(this);
    var conf=$.extend(true,{
        pos:[0,0],
        cell_size:10,
        type:""
    },conf);
    this.conf=conf;
    this.type="";
    this.x=this.conf.pos[0]*this.conf.cell_size;
    this.y=this.conf.pos[1]*this.conf.cell_size;

//    this.back=new myPixiElement.img({img:"img_cell_hide"})
    var texture= new PIXI.Texture(PIXI.utils.TextureCache["img_cell_back"]);
    texture.frame=new PIXI.Rectangle(this.x,this.y,this.conf.cell_size,this.conf.cell_size);

    this.back=new PIXI.Sprite(texture);

    this.back.anchor.set(0.5);

    this.addChild(this.back);
    this.borderArr=[];


}
walkGameMapElement.prototype = Object.create(PIXI.Container.prototype);
walkGameMapElement.prototype=$.extend(walkGameMapElement.prototype,{
    init:function(){

        this.setType(this.conf.type);
    },
    setType:function(type){

        if(this.type==type){
            return false;
        }
        this.type=type;
        if(type=="d"){
//            this.step.alpha=0;
        }
        else if(type=="w"){
//            this.step.alpha=1;
        }
        else if(type=="s"){
            this.alpha=0;
            this.borderArr=[];
        }
    },
    setBorder:function(border_arr){
        var i;
        var cell_len=this.conf.cell_size/2;
        var conf=[
            {start:[-cell_len,-cell_len],dir:[cell_len*2,0]},
            {start:[cell_len,-cell_len],dir:[0,cell_len*2]},
            {start:[cell_len,cell_len],dir:[-cell_len*2,0]},
            {start:[-cell_len,-cell_len],dir:[0,cell_len*2]}
        ],qconf;
        this.borderArr=[];
        var qxy=[this.x,this.y],xy_start;

        for(i in border_arr){
            if(border_arr[i]>0){
                qconf=conf[i];
                xy_start=[qxy[0]+qconf.start[0],qxy[1]+qconf.start[1]];
                this.borderArr.push({
                    start:xy_start,
                    end:[xy_start[0]+qconf.dir[0],xy_start[1]+qconf.dir[1]]
                });
            }
        }
    }
});

function walkGameMap(conf){
    PIXI.Container.call(this);
    var conf=$.extend(true,{
        size:[40,25],
        clearRegionOnSize:6,
        cell_size:10
    },conf);

    this.conf=conf;
    this.fields={};
    this.objSet={};
    this.size_full=0;
    this.size_cur=0;
    var i,k,type;
    for(i=0;i<conf.size[0];i++){
        this.fields[i]={};
        this.objSet[i]={};
        for(k=0;k<conf.size[1];k++){
            if(k==0 || k==conf.size[1]-1 || i==0 || i==conf.size[0]-1){
                type="s";
            }
            else{
                type="d";
                this.size_full++;
            }
            this.fields[i][k]=type;//h->hide,s->show,w->walk
            this.objSet[i][k]=new walkGameMapElement({
                cell_size:conf.cell_size,
                type:type,
                pos:[intval(i),intval(k)]
            });
            this.objSet[i][k].init();
            this.addChild(this.objSet[i][k]);
        }
    }

    this.size_cur=this.size_full;

    this.walk_ends=[[],[]];
    this.path=[];
    this.pathLine=new PIXI.Graphics();
    this.borderLine=new PIXI.Graphics();
    this.borderLine.alpha=0.3;

    this.addChild(this.borderLine);
    this.addChild(this.pathLine);



}
/*
 *
 * 7 0 1
 * 6   2
 * 5 4 3
 *
 */
walkGameMap.prototype = Object.create(PIXI.Container.prototype);
walkGameMap.prototype=$.extend(walkGameMap.prototype,{
    init:function(){
//        this.prepareTest();

        var i;
        for(i=2;i<this.conf.size[0]-2;i++){
            this.objSet[i][1].setBorder([1,0,0,0]);
            this.objSet[i][this.conf.size[1]-2].setBorder([0,0,1,0]);
        }
        for(i=2;i<this.conf.size[1]-2;i++){
            this.objSet[1][i].setBorder([0,0,0,1]);
            this.objSet[this.conf.size[0]-2][i].setBorder([0,1,0,0]);
        }
        this.objSet[1][1].setBorder([1,0,0,1]);
        this.objSet[this.conf.size[0]-2][1].setBorder([1,1,0,0]);
        this.objSet[this.conf.size[0]-2][this.conf.size[1]-2].setBorder([0,1,1,0]);
        this.objSet[1][this.conf.size[1]-2].setBorder([0,0,1,1]);
        this.drawBorder();
    },
    updateView:function(){

    },
    takeField:function(pos){
        if(typeof this.fields[pos[0]]=="undefined" || typeof this.fields[pos[0]][pos[1]]=="undefined"){
            return "none";
        }
        return this.fields[pos[0]][pos[1]];
    },
    takeXY:function(pos){
        var ready=[pos[0]*this.conf.cell_size,pos[1]*this.conf.cell_size];
        return ready;
    },
    drawPath:function(pos_start,arr){
        this.pathLine.clear();
        var i,len=arr.length;
        if(len==0){
            return false;
        }
        this.pathLine.lineStyle(7, 0x000000,0.4);
        var xy_start=this.takeXY(pos_start),xy;


        this.pathLine.moveTo(xy_start[0],xy_start[1]);
        for(i=0;i<len;i++){
            xy=this.takeXY(arr[i].pos);
            this.pathLine.lineTo(xy[0],xy[1]);
        }
        this.pathLine.endFill();

        this.pathLine.lineStyle(5, 0xffffff);
        this.pathLine.moveTo(xy_start[0],xy_start[1]);
        for(i=0;i<len;i++){
            xy=this.takeXY(arr[i].pos);
            this.pathLine.lineTo(xy[0],xy[1]);
        }
        this.pathLine.endFill();

        return true;
    },
    addPath:function(pos_start,pos,dir){
//        this.objSet[pos[0]][pos[1]].setType("w");
        this.fields[pos[0]][pos[1]]="w";

        this.path.push({pos:copyArray(pos),dir:copyArray(dir)});

        this.drawPath(pos_start,this.path);
    },
    clearPath:function(){
        var i,pos;
        for(i in this.path){
            pos=this.path[i].pos;
            this.fields[pos[0]][pos[1]]="d";
            this.objSet[pos[0]][pos[1]].setType("d");
        }
        this.path=[];
        this.drawPath([],[]);
    },
    fillOneRegion:function(seed){
        var region={};
        region[seed[0]]={};
        region[seed[0]][seed[1]]=1;
        var fields_cur=$.extend(true,{},this.fields);





        var stack=[[seed[0],seed[1]]];
        var moveArr=[
          [1,0],[0,1],[-1,0],[0,-1]
        ],move,m;
        while(stack.length>0){
            seed=stack.pop();
            if(fields_cur[seed[0]][seed[1]]=="d"){
                fields_cur[seed[0]][seed[1]]="w";
                if(typeof region[seed[0]]=="undefined"){
                    region[seed[0]]={};
                }
                region[seed[0]][seed[1]]=1;
                for(m in moveArr){
                    move=moveArr[m];
                    stack.push([seed[0]+move[0],seed[1]+move[1]]);
                }
            }
        }
        return region;
    },
    findRegions:function(security_arr){
        var regions_arr=[];
        var i,k;
        var pos,pos_cur,move;
        var moveArr=[
          [1,0],[0,1],[-1,0],[0,-1]
        ];
        var checkAlready={};
        //check points nearly walk path to find seed
        for(i in this.path){
            pos=this.path[i].pos;
            for(k in moveArr){
                move=moveArr[k];
                pos_cur=[pos[0]+move[0],pos[1]+move[1]];
                if(this.fields[pos_cur[0]][pos_cur[1]]=="d"){
                    if(typeof checkAlready[pos_cur[0]]=="undefined"){
                        checkAlready[pos_cur[0]]={};
                    }
                    if(typeof checkAlready[pos_cur[0]][pos_cur[1]]=="undefined"){
                        //check if seed is in any region
                        var in_region=0;
                        var qregion,r;
                        for(r in regions_arr){
                            qregion=regions_arr[r];
                            if(typeof qregion[pos_cur[0]]!="undefined" &&
                            typeof qregion[pos_cur[0]][pos_cur[1]]!="undefined"){
                                in_region=1;
                                break;
                            }
                        }
                        if(in_region==0){
                            regions_arr.push(this.fillOneRegion(pos_cur));
                            //have seed: pos_cur
                        }

                        checkAlready[pos_cur[0]][pos_cur[1]]=1;
                    }
                }
            }
        }
        var sec2del=this.updateRegions(regions_arr,security_arr);

        this.updateView();


//        this.testDrawRegions(regions_arr);

        return sec2del;

    },
    updateRegions:function(regions_arr,security_arr){
        var qregion,r,sec,i,k,pos,in_region_arr;
        var newPoints,pointsAll=[];
        var sec2del=[];
        for(r in regions_arr){
            qregion=regions_arr[r];
            in_region_arr=[];
            for(i in security_arr){
                //check if security is in region
                sec=security_arr[i].pos;
                if(typeof qregion[sec[0]]!="undefined" &&
                typeof qregion[sec[0]][sec[1]]!="undefined"){
                    in_region_arr.push(security_arr[i].id);
                }
            }
            newPoints=[];
            for(i in qregion){
                for(k in qregion[i]){
                    pos=[intval(i),intval(k)];
                    newPoints.push([pos[0],pos[1]]);
                }
            }
            if(in_region_arr.length>0){
                if(newPoints.length>this.conf.clearRegionOnSize){
                    //region is defended by security
                    newPoints=[];
                }
                else{
                    //region is too small for defense
                    for(i in in_region_arr){
                        sec2del.push(in_region_arr[i]);
                    }
                }
            }
            if(newPoints.length){
                for(i in newPoints){
                   pos=newPoints[i];
                   this.fields[pos[0]][pos[1]]="s";
                   this.objSet[pos[0]][pos[1]].setType("s");
                   this.size_cur--;
                }
            }
        }

        var secObj={};
        for(i in security_arr){
            //prepare for checking if security is on the path
            pos=security_arr[i].pos;
            if(typeof secObj[pos[0]]=="undefined"){
                secObj[pos[0]]={};
            }
            secObj[pos[0]][pos[1]]=intval(security_arr[i].id);
        }


        for(i in this.path){
            pos=this.path[i].pos;
            this.fields[pos[0]][pos[1]]="s";
            this.objSet[pos[0]][pos[1]].setType("s");
            this.size_cur--;

            if(typeof secObj[pos[0]]!="undefined" && typeof secObj[pos[0]][pos[1]]!="undefined"){
                if(!in_array(secObj[pos[0]][pos[1]],sec2del)){
                    //delete security from path(very rare)
                    sec2del.push(secObj[pos[0]][pos[1]]);
                }
            }
        }


        this.setNewBorderPath();

        this.path=[];

        this.drawPath([],[]);

        return {sec2del:sec2del,size_cur:this.size_cur,size_full:this.size_full};
    },
    drawBorder:function(){
        this.borderLine.clear();
        this.borderLine.lineStyle(1, 0x000000);


        var i,k,g,obj;
        for(i=0;i<this.conf.size[0];i++){
            for(k=0;k<this.conf.size[1];k++){
                if(this.fields[i][k]=="d"){
                    for(g in this.objSet[i][k].borderArr){
                        obj=this.objSet[i][k].borderArr[g];

                        this.borderLine.moveTo(obj.start[0],obj.start[1]);
                        this.borderLine.lineTo(obj.end[0],obj.end[1]);
                    }
                }
            }
        }
        this.borderLine.endFill();


    },
    setNewBorderPath:function(){
        var moveArr=[
          [0,-1],[1,0],[0,1],[-1,0]
        ];
        var i,k,d,pos_path,pos_neighbor,pos,checked={},move,val,neighbor;
        for(i in this.path){
            pos_path=this.path[i].pos;

            for(k in moveArr){
                move=moveArr[k];
                pos=[pos_path[0]+move[0],pos_path[1]+move[1]];
                if(typeof checked[pos[0]]=="undefined"){
                    checked[pos[0]]={};
                }
                if(typeof checked[pos[0]][pos[1]]=="undefined"){
                    checked[pos[0]][pos[1]]=1;
                    if(this.fields[pos[0]][pos[1]]=="d"){
                        neighbor=[];
                        for(d in moveArr){
                            move=moveArr[d];
                            pos_neighbor=[pos[0]+move[0],pos[1]+move[1]];
                            val=0;
                            if(this.fields[pos_neighbor[0]][pos_neighbor[1]]=="s"){
                                val=1;
                            }
                            neighbor.push(val);
                        }
                        this.objSet[pos[0]][pos[1]].setBorder(neighbor);
                    }
                }
            }

        }
        this.drawBorder();
    },
    takeSize:function(){
        return this.conf.size;
    }

});
